import React from "react";

import { PositionType } from "../types";

type GradientProps = {
  id: string;
  positions: PositionType;
};

const Gradient = (props: GradientProps) => {
  const { height } = props.positions;
  const id = props.id;

  const gradientId = `${id}-start-gradient`;
  const snow = "var(--section-snow-background-color,var(--snow))";

  return (
    <g className={`${id}-gradient`}>
      <rect
        x={0}
        width={80}
        height={height - 17}
        fill={`url(#${gradientId})`}
      />

      <defs>
        <linearGradient
          id={gradientId}
          x1="0.28125"
          y1="78"
          x2="80"
          y2="81"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0572917" stopColor={snow} />
          <stop offset="0.416245" stopColor={snow} stopOpacity="0.9375" />
          <stop offset="0.9999" stopColor={snow} stopOpacity="0" />
          <stop offset="1" stopColor={snow} stopOpacity="0" />
        </linearGradient>
      </defs>
    </g>
  );
};
export default Gradient;
//
